/*
***
  Static Variables
***
*/
import moment from "moment";
import { TbUsers } from "react-icons/tb";
import { FaRegUser } from "react-icons/fa";
import secureLocalStorage from "react-secure-storage";
import { IoChatbubblesOutline } from "react-icons/io5";
import {
  Calendar,
  DollarSign,
  FileText,
  Filter,
  MessageCircle,
  Send,
} from "react-feather";

const user = JSON.parse(secureLocalStorage.getItem("userData"));
const currentUnitId = () =>
  JSON.parse(secureLocalStorage.getItem("currentUnitId"));

export const todayLeadStatus = [1, 2, 3];

const currentDate = new Date();
export const firstDayOfMonth = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth(),
  1,
);

export const EMAIL_VALIDATION_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const MOBILE_REGEX = /android|iphone/i;

export const UTC_TIME_ZONE = "+00:00";

export const IsNotValue = [
  null,
  "null",
  undefined,
  "undefined",
  "",
  "<p></p>",
  "<p></p>\n",
  "<p>&nbsp;</p>",
  "<p>&nbsp;</p>\n",
  "Invalid Date",
];

// Housing User Type
export const housingUserType = [
  { value: 0, label: "Builder" },
  { value: 1, label: "Broker" },
];

export const Tags = "h4" ? "h4" : "ul";

export const StaffStatus = [
  { value: 0, label: "Active" },
  { value: 1, label: "Inactive" },
];

export const customerTab = [
  { value: 0, label: "Active" },
  { value: 1, label: "Deactive" },
];

export const profileTab = [
  { name: "Personal Info", value: "1" },
  { name: "Change Password", value: "2" },
];

export const modulesOptions = [
  { label: "Lead", field: "lead", value: false, transfer: true },
  { label: "Task", field: "task", value: false, transfer: true },
  { label: "Invoice", field: "invoice", value: false, transfer: true },
  { label: "Quotation", field: "quotation", value: false, transfer: true },
  { label: "Reminder", field: "reminder", value: false, transfer: true },
  { label: "Meeting", field: "meeting", value: false, transfer: true },
  { label: "Chat", field: "chat", value: false, transfer: false },
  { label: "Attendance", field: "attendance", value: false, transfer: false },
  // { label: "Invoice", field: "invoice", value: false },
  {
    label: "Global Search",
    field: "global_search",
    value: false,
    transfer: false,
  },
  // { label: "Accounting", field: "accounting", value: false },
  // { label: "Quotation", field: "quotation", value: false },
  { label: "Todo", field: "todo", value: false, transfer: true },
  { label: "Department", field: "department", value: false, transfer: false },
  {
    label: "Add Todo",
    field: "custom_todo_insert",
    value: false,
    transfer: false,
  },
  {
    label: "Update Todo",
    field: "custom_todo_update",
    value: false,
    transfer: false,
  },
  { label: "Service", field: "service", value: false, transfer: true },
];

export const DynamicFieldButtons = [
  { title: "Text Field", type: "text" },
  { title: "TextArea Field", type: "textarea" },
  { title: "Dropdown", type: "dropdown" },
  { title: "Radio", type: "radio" },
  { title: "CheckBox", type: "checkbox" },
  { title: "Date Field", type: "date" },
  { title: "Time Field", type: "time" },
  { title: "Date-Time Field", type: "datetime" },
  { title: "Link Field", type: "link" },
  { title: "Country-State-City Dropdown", type: "countryStateCity" },
];

export const modulePermissionDefaultValues = {
  lead: 0,
  task: 0,
  reminder: 0,
  meeting: 0,
  chat: 0,
  attendance: 0,
  invoice: 0,
  global_search: 0,
  accounting: 0,
  quotation: 0,
  todo: 0,
  service: 0,
  custom_todo_insert: 0,
  custom_todo_update: 0,
};

export const departmentPermissionDefaultValue = {
  department_id: 0,
  is_dept_admin: 0,
  permissions: modulePermissionDefaultValues,
};

export const permissionDefaultValues = {
  userPermission: [
    {
      unit_id: 0,
      is_unit_admin: 0,
      departments: [departmentPermissionDefaultValue],
      permissions: modulePermissionDefaultValues,
    },
  ],
};

export const defaultFilterValueForLead = {
  searchlabel: 0,
  searchStaff: 0,
  searchCreatedId: 0,
  searchvalue: "",
  start_date: "",
  end_date: "",
  status_id: 0,
  source_id: 0,
  followupFilter: 1,
  deptFilter: 0,
  is_unit_admin: 0,
  order_type: 0,
  followup_start_date: "",
  followup_end_date: "",
  followup_date_type: undefined,
  next_followup_start_date: "",
  next_followup_end_date: "",
  next_followup_date_type: undefined,
  created_start_date: "",
  created_end_date: "",
  created_date_type: undefined,
  cancel_date: "",
  cancel_start_date: "",
  cancel_end_date: "",
  confirm_date: "",
  confirm_start_date: "",
  confirm_end_date: "",
  t_country_id: "",
  t_state_id: "",
  t_city_id: "",
};

export const reportsTab = [
  ...(([1, 2].includes(user?.type) && currentUnitId !== 0) ||
  user?.finalPermission?.is_unit_admin === 1
    ? [{ name: "Lead", type: "lead" }]
    : []),
  ...(([1, 2].includes(user?.type) && currentUnitId !== 0) ||
  user?.finalPermission?.is_unit_admin === 1
    ? [{ name: "Task", type: "task" }]
    : []),
  ...(([1, 2].includes(user?.type) && currentUnitId !== 0) ||
  user?.finalPermission?.is_unit_admin === 1
    ? [{ name: "Service", type: "service" }]
    : []),

  { name: "Staff", type: "staff" },
  { name: "SOP", type: "sop" },
];

export const generalReportsList = {
  lead: [
    ...(([1, 2].includes(user?.type) && currentUnitId !== 0) ||
    user?.finalPermission?.is_unit_admin === 1
      ? [
          { name: "Status Or User Wise", key: "statuswiselead" },
          { name: "Status With Time Wise", key: "timewiselead" },
          { name: "Third Party Wise", key: "thirdpartywiselead" },
          { name: "Source Wise", key: "sourcewiselead" },
          { name: "Label Wise", key: "labelwiselead" },
          { name: "Date Wise Followup", key: "leadfollowup" },
          { name: "User Wise Followup", key: "leadfollowupwiseuser" },
          { name: "Customer Wise Followup", key: "leadfollowupwisecustomer" },
        ]
      : []),
  ],
  task: [
    ...(([1, 2].includes(user?.type) && currentUnitId !== 0) ||
    user?.finalPermission?.is_unit_admin === 1
      ? [
          { name: "Status Wise", key: "statuswisetask" },
          { name: "Label Wise", key: "labelwisetask" },
          { name: "Priority Wise", key: "taskpriority" },
          { name: "Delay Task Report", key: "delaytaskreport" },
        ]
      : []),
  ],
  service: [
    ...(([1, 2].includes(user?.type) && currentUnitId !== 0) ||
    user?.finalPermission?.is_unit_admin === 1
      ? [
          { name: "Staff Wise Report", key: "staffwiseservice" },
          { name: "Customer Wise Report", key: "customerwiseservice" },
          { name: "Status Wise Report", key: "statuswiseservice" },
          {
            name: "Staff Wise Delay Service Report",
            key: "delayservicereport",
          },
        ]
      : []),
  ],
  staff: [{ name: "Attendance Report", key: "staffreport" }],
  sop: [{ name: "Staff Wise SOP Report", key: "staffSOPReport" }],
};

export const leadReportsKeys = [
  "statuswiselead",
  "timewiselead",
  "thirdpartywiselead",
  "sourcewiselead",
  "labelwiselead",
  "leadfollowup",
  "leadfollowupwiseuser",
  "leadfollowupwisecustomer",
];

export const taskReportsKeys = [
  "statuswisetask",
  "labelwisetask",
  "taskpriority",
  "delaytaskreport",
];

export const serviceReportsKeys = [
  "staffwiseservice",
  "customerwiseservice",
  "statuswiseservice",
  "delayservicereport",
];

export const reportLabelOptions = [
  {
    value: 0,
    label: "All Labels",
  },
  { value: -1, label: "No Labels" },
];

export const leadHeader = {
  statuswiselead: "Lead Status Wise Report",
  timewiselead: "Wise Lead Status Report",
  thirdpartywiselead: "Lead Third Party Source Wise Report",
  sourcewiselead: "Lead Source wise Report",
  labelwiselead: "Lead Label Wise Report",
  leadfollowup: "Lead Followup Wise Report",
  leadfollowupwiseuser: "User Wise Lead Followup",
  leadfollowupwisecustomer: "Customer Wise Lead Followup",
};

export const taskHeader = {
  statuswisetask: "Task Status Wise Report",
  labelwisetask: "Task Label Wise Report",
  taskpriority: "Task Priority Wise Report",
  delaytaskreport: "Task Delay Report",
};

export const serviceHeader = {
  staffwiseservice: "Staff Wise Service Report",
  customerwiseservice: "Customer Wise Service Report",
  statuswiseservice: "Status Wise Service Report",
  delayservicereport: "Staff Wise Delay Service Report",
};

export const dateSearchFilter = [
  { value: 1, label: "By Follow-up Date" },
  { value: 2, label: "By Next Follow-up Date" },
  { value: 3, label: "By Created Date" },
];

// Lead Kanban Setting Options
export const kanbanSettingsOption = [
  { value: 1, key: "name", label: "Customer Name", isTrue: true },
  { value: 2, key: "company_name", label: "Company Name", isTrue: true },
  { value: 3, key: "mo_no", label: "Phone", isTrue: true },
  { value: 4, key: "date", label: "Created Date", isTrue: true },
  { value: 5, key: "createdBy", label: "Created By", isTrue: true },
  { value: 6, key: "assignTo", label: "Assign To", isTrue: true },
  {
    value: 7,
    key: "next_followup_date",
    label: "Next Follow up Date",
    isTrue: true,
  },
  { value: 8, key: "address", label: "Address", isTrue: true },
];

export const defaultLeadValue = {
  c_id: 0,
  created_by: user?.u_id,
  createdBy: user?.first_name + " " + user?.last_name,
  label: [],
  l_id: 0,
  status_id: 1,
  source_id: 6,
  mo_no: "",
  assign_to: user?.u_id,
  date: moment().format("YYYY-MM-DD"),
};

export const ExpoColumnsCsvForLead = [
  { label: "Customer Name", key: "name" },
  { label: "Company Name", key: "company_name" },
  { label: "Date", key: "date" },
  { label: "Created By", key: "createdBy" },
  { label: "Assign To", key: "assignTo" },
  { label: "Mobile", key: "mo_no" },
  { label: "Email", key: "email" },
  { label: "Label", key: "labelName" },
  { label: "Reference", key: "reference" },
  { label: "Source", key: "source_name" },
  { label: "Status", key: "status_name" },
  { label: "Comment", key: "comment" },
  { label: "Address", key: "address" },
];

export const defaultReminderFieldValue = {
  type: 0,
  created_by: user?.u_id,
  assign_to: user?.u_id,
  repeat_date: new Date(),
  email_auto: 0,
  wp_auto: 0,
  m_email: "",
  rem_type: 0,
  m_mobile: user?.country_code?.split("-")[1],
  message: "",
};

export const todoDetailsTab = [
  {
    value: "1",
    label: "Todo Details",
  },
  {
    value: "2",
    label: "Todo Attachment",
  },
];

export const TabForLeadDetailsModal = [
  { label: "Details", active: "1" },
  { label: "FollowUp", active: "2" },
  { label: "History", active: "3" },
  { label: "Attachment", active: "4" },
  { label: "Task", active: "5" },
  { label: "Meeting", active: "6" },
  { label: "Reminder", active: "7" },
  { label: "Quotation", active: "8" },
  { label: "Invoice", active: "9" },
];

export const imageTypes = [
  "png",
  "jpg",
  "jpeg",
  "gif",
  "webp",
  "jfif",
  "bmp",
  "tiff",
  "tif",
  "svg",
  "ico",
  "heic",
  "heif",
  "avif",
  "raw",
  "cr2",
  "nef",
  "arw",
  "dng",
];

export const videoTypes = [
  "mp4",
  "webm",
  "ogg",
  "mov",
  "avi",
  "mkv",
  "flv",
  "wmv",
  "m4v",
  "3gp",
  "3g2",
  "mpg",
  "mpeg",
  "m2v",
  "m4p",
  "ts",
  "vob",
  "asf",
  "rm",
  "rmvb",
];

export const audioTypes = [
  "mp3",
  "wav",
  "ogg",
  "flac",
  "aac",
  "m4a",
  "wma",
  "opus",
  "aiff",
  "aif",
  "au",
  "ra",
  "amr",
  "mid",
  "midi",
  "oga",
  "weba",
];

export const mediaTypes = [...imageTypes, ...videoTypes, ...audioTypes];

export const documentTypes = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "txt",
  "rtf",
  "odt",
  "ods",
  "odp",
  "csv",
  "epub",
];

export const archiveTypes = [
  "zip",
  "rar",
  "7z",
  "tar",
  "gz",
  "bz2",
  "xz",
  "iso",
  "cab",
  "dmg",
];

export const leadInformationVariable = [
  { label: "Name", field: "name" },
  { label: "Company Name", field: "company_name" },
  { label: "Phone", field: "mo_no" },
  { label: "Email Address", field: "email" },
  { label: "Address", field: "address" },
  { label: "Comment", field: "comment" },
  { label: "Reference", field: "reference" },
];

export const TabForReminderOrMeeting = [
  { value: 0, label: "Once" },
  { value: 1, label: "Daily" },
  { value: 2, label: "Weekly" },
  { value: 3, label: "Monthly" },
  { value: 5, label: "Quarterly" },
  { value: 6, label: "Half-Yearly" },
  { value: 4, label: "Yearly" },
];

export const WeekOptions = [
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
  { value: 7, label: "Sunday" },
];

export const compressType = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "application/pdf",
];

export const reminderAndMeetingDefaultFilter = {
  is_unit_admin: 0,
  deptFilter: 0,
  created_by: 0,
  assign_to: 0,
  type: -1,
  search_value: "",
  start_date: "",
  end_date: "",
  order_type: 0,
};

export const ReminderAndMeetingInformation = [
  { label: "Customer Name", field: "c_name" },
  { label: "Customer Mobile No.", field: "c_mo_no" },
  { label: "Message", field: "message" },
  { label: "Mobile Number", field: "m_mobile" },
  { label: "Email Address", field: "m_email" },
  { label: "Type", field: "type" },
  { label: "Created By", field: "created_by" },
  // { label: "Company Name", field: "unit_id" },
];

export const MeetingStatus = [
  { value: 1, label: "Pending" },
  { value: 2, label: "Completed" },
  { value: 3, label: "Missing" },
];

export const TabForMeetingModal = [
  { label: "Meeting Details", active: "1" },
  { label: "Meeting History", active: "2" },
  // { label: "Tracking Details", active: "3" },
];

export const invoiceTypes = [
  { value: 3, label: "ALL" },
  { value: 0, label: "GST" },
  { value: 1, label: "Non GST" },
];

export const TaskPriority = [
  { value: 1, label: "Low" },
  { value: 2, label: "Medium" },
  { value: 3, label: "High" },
  { value: 4, label: "Urgent" },
];

export const defaultAssignUserValue = [
  {
    dept_id: 0,
    assign_to: [],
  },
];

export const defaultTaskFilter = {
  filterstaff: 0,
  searchvalue: "",
  searchCreatedId: 0,
  start_date: "",
  end_date: "",
  // searchlabel: 0,
  searchlabel: [{ value: 0, label: "All Labels" }],
  searchpriority: 0,
  deptFilter: 0,
  is_unit_admin:
    user?.type == 0 ? (user?.finalPermission?.is_unit_admin == 1 ? 1 : 0) : 1,
  isCreatedByAndAssignToOr: 1,
  status_id: 0,
  start_date_type: -1,
  order_type: 0,
};

export const defaultTaskData = {
  u_id: user?.u_id,
  assign_to: user?.u_id,
  priority: 1,
  start_date: moment().format("DD-MM-YYYY"),
  end_date: moment().add(1, "d").format("DD-MM-YYYY"),
  status_id: 10,
  r_type: 0,
  type: 0,
  r_date: moment().format("DD-MM-YYYY"),
};

export const renderTaskTab = [
  { label: "Task Details", value: "1" },
  { label: "Task Comments", value: "2" },
  { label: "Task Attachment", value: "3" },
  { label: "Task History", value: "4" },
  // { label: "Tracking Details", value: "5" },
];

export const exportCustomerColumns = [
  { label: "name", key: "name" },
  { label: "number", key: "mo_no" },
  { label: "email", key: "email" },
  { label: "address", key: "address" },
];

export const defaultCustomerFilter = {
  deptFilter: 0,
  searchStaff: 0,
  searchvalue: "",
  start_date: "",
  end_date: "",
  is_unit_admin: 0,
};

export const customerExpandableTable = [
  { field: "name", label: "Customer Name :" },
  { field: "company_name", label: "Company Name :" },
  { field: "email", label: "Email :" },
  { field: "mo_no", label: "Phone :" },
  { label: "Date Of Birth", field: "c_dob" },
  { field: "created_by", label: "Created By :" },
  { field: "converted_by", label: "Converted By :" },
  { field: "converted_date", label: "Converted Date :" },
];

export const customerInformationVariable = [
  { label: "Customer Name", field: "name" },
  { label: "Email Address", field: "email" },
  { label: "Phone", field: "mo_no" },
  { label: "Converted By", field: "converted_by" },
  { label: "Company Name", field: "company_name" },
  { label: "Date Of Birth", field: "c_dob" },
  { label: "Rating", field: "rating" },
];

export const webSettingTab = [
  { name: "General Settings", value: 1 },
  { name: "Invoice Settings", value: 2 },
  { name: "General Integrations", value: 3 },
  { name: "Third Party Integrations", value: 4 },
  { name: "Dynamic Lead Form Settings", value: 5 },
];

export const defaultTodayTodoValues = {
  title: "",
  priority: "",
  label: [],
  is_carry_forward: true,
  todo_date: new Date(),
  userAssignList: defaultAssignUserValue,
};

export const defaultTodoValues = {
  title: "",
  priority: "",
  recursive_type: 1,
  userAssignList: defaultAssignUserValue,
  is_carry_forward: true,
  recursive_date: new Date(),
  label: [],
  usersListType: 0,
};

export const recursiveType = [
  { value: 1, label: "Daily" },
  { value: 2, label: "Weekly" },
  { value: 3, label: "Monthly" },
  { value: 4, label: "Yearly" },
];

export const todoPriority = [
  { value: 1, label: "High" },
  { value: 2, label: "Medium" },
  { value: 3, label: "Low" },
];

export const todoStatus = [
  { value: -1, label: "All Todo" },
  { value: 1, label: "Completed" },
  { value: 2, label: "Pending" },
];

export const defaultCustomTodoAssign = [
  {
    dept_id: "",
    assign_to: [],
  },
];

export const defaultCustomTodoTitle = [
  {
    title: "",
    description: "",
  },
];

export const defaultTodoFilter = {
  priority: "",
  deptFilter: 0,
  report_type: -1,
  is_unit_admin: 0,
  userAssignId: "",
  start_date: moment().startOf("month").format("DD-MM-YYYY HH:mm"),
  end_date: moment().endOf("month").format("DD-MM-YYYY HH:mm"),
};

export const calendarsColor = {
  Business: "primary",
  Holiday: "success",
  Personal: "danger",
  Family: "warning",
  ETC: "info",
  Reminder: "dark",
};

export const blankEvent = {
  title: "",
  start: "",
  end: "",
  allDay: false,
  url: "",
  extendedProps: {
    calendar: "",
    guests: [],
    location: "",
    description: "",
  },
};

export const leadFollowUpFieldList = [
  { field: "title", label: "Customer Name" },
  { field: "mo_no", label: "Phone" },
  { field: "email", label: "Email" },
  { field: "next_followup_date", label: "Next FollowUp Date" },
  { field: "createdBy", label: "Created By" },
  { field: "assignTo", label: "Assign To" },
  { field: "status_name", label: "Status Name" },
  { field: "source_name", label: "Source Name" },
];

export const chatTab = [
  {
    value: "1",
    icon: <IoChatbubblesOutline size="18" className="me-0" />,
    title: "Chat",
    filterValue: "",
  },
  {
    value: "2",
    icon: <FaRegUser size="18" className="me-0" />,
    title: "Single Chat",
    filterValue: 0,
  },
  {
    value: "3",
    icon: <TbUsers size="18" className="me-0" />,
    title: "Group Chat",
    filterValue: 1,
  },
];

export const chatUploadFilesAccepted = {
  "image/*": [".png", ".jpg", ".jpeg", ".gif", ".svg"],
  "application/*": [
    ".ppt",
    ".ppsx",
    ".odp",
    ".doc",
    ".docx",
    ".pdf",
    ".txt",
    ".xlsx",
    ".xls",
  ],
  "video/*": [".mp4", ".webm"],
  "text/*": [".csv"],
};

export const urlRegex = /(https?:\/\/[^\s]+)/g;

export const CustomerTab = [
  { label: "Leads", active: "1" },
  { label: "Quotation", active: "2" },
  { label: "Invoice", active: "3" },
  { label: "Reminder", active: "4" },
  { label: "Service", active: "5" },
  { label: "Greetings", active: "6" },
  { label: "Attachment", active: "0" },
  { label: "History", active: "7" },
];

export const defaultQty = { staff: 1, company: 1 };

export const staffDetailFieldList = [
  { field: "first_name", label: "First Name" },
  { field: "last_name", label: "Last Name" },
  { field: "email", label: "Email" },
  { field: "mo_no", label: "Phone" },
  { field: "u_dob", label: "Birth Date" },
  { field: "type", label: "Organization Admin" },
];

export const sopReportHeader = {
  staffSOPReport: "Staff Wise SOP Report",
};

export const SOPReportsKeys = ["staffSOPReport"];

export const customerSortingOptions = [
  { value: 1, label: "By Customer Name" },
  { value: 2, label: "By Company Name" },
  { value: 3, label: "By Convert Date" },
];

export const leadSortingOptions = [
  { value: 1, label: "By Last Status Change Date" },
  { value: 2, label: "By Created Date" },
  { value: 3, label: "By Next Followup Date" },
  { value: 4, label: "By Last Followup Taken" },
];

export const leadSortingOrderTypeOptions = [
  { value: "ASC", label: "ASC" },
  { value: "DESC", label: "DESC" },
];

export const sortingType = [
  { value: "asc", label: "Ascending" },
  { value: "desc", label: "Descending" },
];

export const defaultCustomerSortingOptions = {
  orderField: 3,
  orderType: "desc",
};

export const defaultLeadSortingOptions = {
  orderField: 1,
  orderType: "DESC",
};

export const defaultSortingOptions = {
  orderField: 1,
  orderType: "desc",
};

export const tabForServiceDurationType = [
  { value: 0, label: "Days" },
  { value: 1, label: "Monthly" },
  { value: 2, label: "Yearly" },
  { value: 3, label: "Custom" },
];

export const repeatTimeList = [
  { value: 1, label: "1 Month" },
  { value: 2, label: "2 Month" },
  { value: 3, label: "3 Month" },
  { value: 4, label: "4 Month" },
  { value: 5, label: "5 Month" },
  { value: 6, label: "6 Month" },
  { value: 7, label: "7 Month" },
  { value: 8, label: "8 Month" },
  { value: 9, label: "9 Month" },
  { value: 10, label: "10 Month" },
  { value: 11, label: "11 Month" },
];

export const defaultFilterValueForService = {
  serachDepartment: 0,
  searchStatus: { value: 0, label: "All Status" },
  searchStaff: [{ value: 0, label: "All Assign To" }],
  searchCreatedId: [{ value: 0, label: "All Created By" }],
  searchCustomer: [{ value: 0, label: "All Customer" }],
  searchValue: "",
  start_date: "",
  end_date: "",
  order_type: 0,
};

export const serviceInformationVariable = [
  { label: "Service Name", field: "service_name" },
  { label: "Customer Name", field: "name" },
  { label: "Description", field: "description" },
];

export const TabForServiceDetailsModal = [
  { label: "Details", active: "1" },
  { label: "History", active: "2" },
  { label: "Attachment", active: "3", counter_field: "attachment" },
];

export const serviceGeneralInformationVariable = [
  { label: "Service Date", field: "service_date" },
  { label: "Status", field: "status" },
  { label: "Created By", field: "created_by" },
  { label: "Assign To", field: "assign_to" },
];

export const serviceFieldList = [
  { field: "name", label: "Customer Name" },
  { field: "mo_no", label: "Phone" },
  { field: "service_date", label: "Service Date" },
  { field: "status", label: "Status" },
  { field: "created_by", label: "Created By" },
  { field: "assign_to", label: "Assign To" },
  { field: "description", label: "Description" },
];

export const defaultReportData = { categories: [], series: [] };

export const defaultCampaignTypes = {
  campType: 0,
  remove_duplicates: 0,
  title: "",
  a_start_date: "",
  a_end_date: "",
};

export const campaignChannelTypes = [
  { label: "Once", value: 2 },
  { label: "Channel", value: 1 },
];

export const campaignScheduleTime = [
  { label: "Now", value: 1 },
  { label: "Schedule Time", value: 2 },
];

export const automationTab = [
  { label: "Email", value: 1 },
  { label: "WhatsApp", value: 2 },
  ...(user?.meta_integration === 1
    ? [{ label: "Whatsapp Meta", value: 3 }]
    : []),
  { label: "SMS", value: 4 },
];

export const campaignTab = [
  { label: "Lead", value: 1 },
  { label: "Customer", value: 2 },
  { label: "Custom", value: 3 },
];

export const StaffStatusForCampaign = [
  { value: 1, label: "Active" },
  { value: 2, label: "Inactive" },
  { value: 3, label: "All" },
];

export const staffNoSelect = [
  { label: "Staff No.", value: 1 },
  { label: "General", value: 2 },
];

export const defaultCampaignFilterValue = {
  campaign_type: -1,
  audience_type: -1,
  searchValue: "",
};

// Custom Customer Import CSV Format for Campaign
export const csvImportFormat = [
  "name",
  "email",
  "number",
  "company_name",
  "gst_no",
  "address",
];

export const twoStepAuthentication = [
  { value: 0, label: "IP" },
  { value: 1, label: "OTP" },
  { value: 2, label: "None" },
];

export const dynamicVariableList = [
  "[[customerName]]",
  "[[customerNumber]]",
  "[[customerEmail]]",
  "[[customerAddress]]",
  "[[customerCompany]]",
  "[[customerGST]]",
  "[[customerVatNo]]",
];

export const webSettingVariable = {
  title: "Are You Sure?",
  text: "You must logout after changing websetting data to update your new settings.",
  confirmBtnText: "Yes, Confirm",
  cancelBtnText: "No",
};

export const attendanceFilterTabs = [
  { label: "All", value: 0 },
  { label: "Check In", value: 1 },
  { label: "Check Out", value: 2 },
];

export const leaveDetailsField = [
  { label: "Start Date", field: "start_date" },
  { label: "End Date", field: "end_date" },
  { label: "Name", field: "staff_id" },
  { label: "Status", field: "status" },
  { label: "Reason", field: "l_reason" },
  { label: "Note", field: "note" },
];

export const discountTypeOptions = [
  { value: 0, label: "Overall Discount" },
  { value: 1, label: "Per Item Discount" },
];

export const brochureOptions = [
  { value: 1, label: "Paid Invoice" },
  { value: 2, label: "Half-Paid Invoice" },
  { value: 3, label: "Unpaid Invoice" },
  { value: 4, label: "Quotation" },
];

export const userLocationTab = [
  { label: "All", value: 1 },
  { label: "Meeting", value: 2 },
  { label: "Task", value: 3 },
  { label: "Lead Followup", value: 4 },
];

export const invoiceTemplateImageArray = [
  { value: 1, image: "preview1.png" },
  { value: 2, image: "preview2.png" },
  { value: 3, image: "preview3.png" },
  { value: 4, image: "preview4.png" },
  { value: 5, image: "preview5.png" },
];

export const defaultPaymentData = {
  p_m_id: "",
  i_paid_amount: 0,
  old_paid_amount: 0,
  new_due_amount: 0,
  p_date: new Date(),
};

export const expo_columns = [
  { label: "name", key: "name" },
  { label: "email", key: "email" },
  { label: "mo_no", key: "mo_no" },
  { label: "company_name", key: "company_name" },
  { label: "c_gstno", key: "c_gstno" },
  { label: "c_dob", key: "c_dob" },
  { label: "anniversary_date", key: "c_a_date" },
  { label: "address", key: "address" },
  { label: "assign tag", key: "c_tag" },
];
export const customerRoute = ["customer-detail", "customer-list"];
export const meetingDynamicVariableList = ["[[dateTime]]"];

export const celebrationDefaultFilterValue = {
  searchValue: "",
  type: 0,
  start_date: "",
  end_date: "",
};

export const grretingsType = [
  { label: "Customer", value: 1 },
  { label: "Other", value: 2 },
];

export const celebrationTemplateTypeRadio = [
  { label: "Birthday", value: 1 },
  { label: "Anniversary", value: 2 },
  { label: "Other", value: 3 },
];

export const dateValue = [
  { startDate: new Date(), endDate: new Date(), key: "selection" },
];

export const invoiceDynamicVaribleList = ["[[totalAmount]]"];
export const hiringDynamicVaribleList = ["[[dateTime]]", "[[vacancy]]"];
export const automationSendDeViceType = [
  { value: 0, label: "Staff Device" },
  { value: 1, label: "General Device" },
];

export const templateSubType = [
  {
    value: 1,
    label: "Lead Template",
    icon: <Filter size={16} />,
    id: "lead",
  },
  {
    value: 2,
    label: "Meeting Template",
    icon: <Calendar size={16} />,
    id: "meeting",
  },
  {
    value: 3,
    label: "Invoice Template",
    icon: <FileText size={16} />,
    id: "invoice",
  },
  {
    value: 7,
    label: "Hiring Template",
    icon: <FileText size={16} />,
    id: "hiring",
  },
];

export const automationTypeList = [
  { value: 0, label: "All Automation Type" },
  ...templateSubType.map((type) => ({
    ...type,
    label: type.label.replace("Template", "Automation"),
  })),
];

export const automationStatusList = [
  { value: -1, label: "All Automation Status" },
  { value: 0, label: "Deactivate Status" },
  { value: 1, label: "Active Status" },
];

export const invoiceTypeList = [
  { value: 0, label: "All Invoice Type" },
  ...invoiceTypes,
];

export const meetingStatus = [
  ...MeetingStatus,
  { value: 4, label: "Rescheduled" },
];

export const meetingStatusList = [
  { value: 0, label: "All Status" },
  ...meetingStatus,
];

export const whatsAppTypeList = [
  { value: -1, label: "All Type" },
  { value: 2, label: "Normal Type" },
  { value: 3, label: "Meta Type" },
];

export const defaultAutomationFilter = {
  automation_type: 0,
  configuration_type: -1,
  status: -1,
  label: 0,
  meeting_status: 0,
  invoice_status: 0,
  automation_status: -1,
  whatsApp_type: -1,
  template: 0,
  currentPage: 0,
  rowPerPage: 10,
};

export const defaultRulesValue = {
  status: [], // Lead Status field
  label: [], // Lead Label Field
  template: 0, // Overall Template Field
  send_type: 0, // Send Type  0- staff, 1-general number
  a_waba_device_id: 0, // WapMonkey Device Field
  a_meeting_status: 0, // Meeting Status Field
  store_id: user?.u_id,
  a_wp_device_token: "", // Device Token Field
  a_u_waba_id: "", // send_type: 0, // Send Type  0- staff, 1-general number
  message: "", // Message
  variables: [], // Variables
  a_t_variables: [], // Title/Subject Variables
  waba_variable_image: "", // Meta Image field
  e_s_id: "", // Email Configuration Field
};

export const invoiceType = [
  {
    value: 1,
    label: "Generated Invoice",
    icon: <FileText size={16} />,
    id: "generated_invoice",
  },
  {
    value: 2,
    label: "Converted Paid Invoice",
    icon: <DollarSign size={16} />,
    id: "paid_invoice",
  },
  {
    value: 3,
    label: "Generated Quotation",
    icon: <FileText size={16} />,
    id: "generated_quotation",
  },
];

export const leadType = [
  {
    value: 1,
    label: "First Message",
    id: "normal",
    icon: <MessageCircle size={16} />,
  },
  {
    value: 2,
    label: "Next Followup",
    id: "n_f_u",
    icon: <Send size={16} />,
  },
];

export const whatsAppType = [
  { value: 2, label: "WapMonkey Automation", id: "wapMonkeyAutomation" },
  { value: 3, label: "Meta Automation", id: "metaAutomation" },
];

export const wapMonkeyApiLogOutError =
  "Your WapMonkey account or device has been disconnected. Please reconnect to continue using the service.";

export const defaultTemplateValue = {
  title: "",
  email_body: "",
  wp_body: "",
  sms_body: "",
  email_subject: "",
  email_variables: [],
  wp_variables: [],
  sms_variables: [],
  title_variables: [],
  subject_variables: [],
  attachment: [],
  files: [],
};

export const defaultReminderFilterValue = {
  type: -1,
  searchValue: "",
  start_date: "",
  end_date: "",
  status: -1,
  order_type: 0,
};

export const mergeCustomerFields = [
  { label: "Customer Name", field: "name" },
  { label: "Company Name", field: "company_name" },
  { label: "Email", field: "email" },
  { label: "Phone", field: "mo_no" },
  user?.country_code?.split("-")[0] != "IN"
    ? { label: "VAT No", field: "c_vatno" }
    : { label: "GST No", field: "c_gstno" },
  { label: "Address", field: "address" },
  { label: "Date Of Birth", field: "c_dob" },
  { label: "Anniversary Date", field: "c_a_date" },
  { label: "Bill Address", field: "bill_address" },
  { label: "Ship Address", field: "ship_address" },
];

export const defaultFilter = {
  start_date: "",
  end_date: "",
  searchvalue: "",
  searchStaff: 0,
  deptFilter: 0,
  page: 1,
  per_page: 10,
  step: 0,
  searchBtnClick: false,
  order_type: 0,
  module: 6,
};

export const hiringDateSearchFilter = [
  { value: 1, label: "By Joining Date" },
  { value: 2, label: "By Schedule Date" },
  { value: 3, label: "By Next Follow-up Date" },
  { value: 4, label: "By Follow-up Date" },
];

export const careerOpportunityCustomerTab = [
  { value: 0, label: "Deactive" },
  { value: 1, label: "Active" },
];

export const DynamicHiringFormFields = [
  { title: "Text Field", type: "text" },
  { title: "Mobile Number Field", type: "mobile" },
  { title: "Email Field", type: "email" },
  { title: "Dropdown", type: "dropdown" },
  { title: "Radio", type: "radio" },
  { title: "CheckBox", type: "checkbox" },
  { title: "File Upload", type: "fileupload" },
  { title: "Country-State-City Dropdown", type: "countryStateCity" },
];


export const inputType = ["dropdown", "radio", "checkbox"];